<template>
  <div>
    <HeaderView :title="$t('withdraw.with_center')" />
    <div class="view-page">
        <div class="withdrawMoney">
        <span>{{$t("withdraw.with_money")}} ({{$t("common.unit")}})</span>
        <div class="money">
          <div class="moneyNumber">
            <span class="moneyType">{{$t("common.unit")}}</span>
            <van-field v-model="withdraw_money" type="number" />
          </div>
          <span class="all" @click="allMoeny()">{{$t("common.all")}}</span>
        </div>
        <div class="information">
          <div class="description">
            <van-popover v-model="showPopover" trigger="click">
              <div class="popover-body" style="padding: 10px;">]
                <p>1.{{$t("withdraw.with_tip")}}</p></div>
              <template #reference>
                <van-icon name="info-o" />
                {{$t("withdraw.limit_desc")}}
              </template>
            </van-popover>
          </div>

          <div class="balance">
            <span>{{$t("mine.available")}}：</span>
            <span class="number">{{ this.userInfo.money }}{{$t("common.unit")}}</span>
          </div>
          <van-field
            v-model="pwd"
            type="password"
            :placeholder="$t('bank.pwdple')"
            :rules="[{ required: true}]"
          />
        </div>
      </div>
      <div v-if="userInfo.withdrawStatus === 0" style="width: 100%;padding: 20px 10px;background-color: #fff;color: red;">
        {{ userInfo.withdrawReason }}
      </div>
      <div v-else style="margin: 16px;">
        <van-button  class="btn" type="default" @click="doWithdraw()"> {{$t("withdraw.immediately_withdraw")}}</van-button>
      
      </div>
      
    </div>
  </div>
</template>

<script>
import HeaderView from '@/components/Header/index.vue'
export default {
  name: 'WithdrawalView',
  components: { HeaderView },
  data() {
    return {
      showPopover: false,
      withdraw_money:"",
      userInfo:{},
      withdrawRole:{},
      pwd:null
    };
  },
  methods: {
    getformatter(val){
      let result = val
      if(!(isNaN(val) || val < 1000))
        result = (val / 1000) +'K'
       return result
    },
    back(){
      return window.history.back();
    },
    getUserInfo(){
      this.$http({
        method: 'get',
        url: 'user_info'
      }).then(res=>{
        if(res.code === 200){
          this.userInfo = res.data;
          console.log(this.userInfo)
          this.name = res.data.name;
        }else if(res.code ===401){
          this.$toast(res.msg);
        }
      })
    },
    getUserWithdrawRole(){
      this.$http({
        method: 'get',
        url: 'user_get_withdraw_role'
      }).then(res=>{
        if(res.code === 200){
          this.withdrawRole = res.data;
        }else if(res.code ===401){
          this.$toast(res.msg);
        }
      })
    },
    allMoeny(){
      this.withdraw_money = this.userInfo.money;
    },
    doWithdraw(){
      if(this.withdraw_money <= 0){
        this.$toast(this.$t("setting.correct_money"));
        return false;
      }else {
        this.$http({
          method: 'post',
          data:{money:this.withdraw_money,pwd:this.pwd},
          url: 'user_set_withdraw'
        }).then(res=>{
          if(res.code === 200){
            location. reload()
            this.$toast(res.msg);
            this.getUserInfo();
            this.getUserWithdrawRole();
          }else if(res.code ===401){
            this.$toast(res.msg);
          }
        })
      }
    },
    withdrawInfo(){
      this.showPopover = true;
    }
  },
  created() {
    if(!localStorage.getItem('token')){
      this.$router.push({path:'/login'})
    }else {
      this.getUserInfo();
      this.getUserWithdrawRole();
    }
  }
}
</script>
<style lang="scss" scoped>
 .withdrawMoney{
  display: flex;
  flex-direction: column;
  color: #000;
  padding: 0 20px;
  white-space: nowrap;
  background-color: #fff;
}
 .withdrawMoney span {
  padding: 10px 0;
}
 .withdrawMoney .money{
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  border-bottom: 1px solid #f2f2f5;
}
 .withdrawMoney .money .moneyNumber{
  display: flex;
  flex-direction: row;
}
 .withdrawMoney span {
  padding: 10px 0;
}
 .withdrawMoney .money .all{
  color: #d10404;
}
 .withdrawMoney .information{
  padding-bottom: 30px;
}
 .withdrawMoney .information .description {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 10px 0;
}
 .withdrawMoney span{
  padding: 10px 0;
}
 .withdrawMoney .information .balance .number{
  color: #d10404;
}
</style>